export { default } from "./loading";
